import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import s from './Message.module.css';

const Message = ({content}) => {

    const {userPhotoURL, userName} = useSelector(({auth}) => auth)
    
    return (
        <div className={s.message}>
            <div className={s.senderInfo}>
                <div className={s.senderPhoto}>
                    <NavLink to='#'>
                        <img src={userPhotoURL} alt="sender Photo"/>
                    </NavLink>
                </div>
                <div className={s.messageTime}>
                    22:42
                </div>
            </div>
            <div className="messageContent">
                <div className={s.messageText}>
                    <div className={s.messageSenderName}>{userName ? userName : 'Unknown Samurai'}</div>
                    {content && content}
                </div>
            </div>
        </div>
    )
}

export default Message
